// src/pages/transportations/EditTransportation.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditTransportation from "../../components/transportations/FormAddEditTransportation";
import useGetTransportation from "../../hooks/transportations/useGetTransportation";
import LoadingPage from "../../components/global/LoadingPage";

const EditTransportation = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const { transportation, isLoading } = useGetTransportation(id);

    const handleSuccess = () => {
        navigate("/transportations");
    };

    if (isLoading) return <LoadingPage />;


    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditTransportation
                isEdit={true}
                currentData={transportation}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditTransportation;
